import { useRef, useState, useLayoutEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

function useMeasure() {
  const ref = useRef();
  const [bounds, set] = useState({ left: 0, top: 0, width: 0, height: 0 });
  const [ro] = useState(() => new ResizeObserver(([entry]) => set(entry.contentRect)));

  useLayoutEffect(() => {
    const element = ref.current;
    if (ro && element) {
      ro.observe(element);
      return () => {
        ro.disconnect();
      };
    }
  }, [ro]);

  return [{ ref }, bounds];
}

export { useMeasure };
